import type { RouteRecordRaw } from 'vue-router';

export const infoSupportRoutes: Array<RouteRecordRaw> = [
  {
    path: '/info/support',
    name: 'infoSupport',
    redirect: '/info/support/request',
  },
  {
    path: '/info/support/category',
    name: 'infoSupportCategory',
    redirect: '/info/support/category/list',
    component: () => import('pages/micros/support/category/SupportCategory.vue'),
    meta: {
      title: 'Support Categories, by group - request, blog, chat, comment, message',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportCategoryList',
        component: () => import('pages/micros/support/category/CategoryList.vue'),
        meta: {
          title: 'Support Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSupportCategoryDetail',
        component: () => import('pages/micros/support/category/CategoryDetail.vue'),
        meta: {
          title: 'Support Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportCategoryNew',
        component: () => import('pages/micros/support/category/CategoryNew.vue'),
        meta: {
          title: 'New Support Category',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'infoSupportCategoryExplorer',
        component: () => import('pages/micros/support/category/CategoryExplorer.vue'),
        meta: {
          title: 'Categories Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/support/room',
    name: 'infoSupportRoom',
    redirect: '/info/support/room/list',
    component: () => import('pages/micros/support/room/SupportRoom.vue'),
    meta: {
      title: 'Rooms [Support Groups] by categories - Public, Private, Message, Request, Blog, Chat',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportRoomList',
        component: () => import('pages/micros/support/room/RoomList.vue'),
        meta: {
          title: 'Rooms [Support Groups] List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSupportRoomDetail',
        component: () => import('pages/micros/support/room/RoomDetail.vue'),
        meta: {
          title: 'Room [Support Group] Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportRoomNew',
        component: () => import('pages/micros/support/room/RoomNew.vue'),
        meta: {
          title: 'New Room [Support Group]',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/support/room/member',
    name: 'infoSupportRoomMember',
    redirect: '/info/support/room/member/list',
    component: () => import('pages/micros/support/roomMember/SupportRoomMember.vue'),
    meta: {
      title: 'Room Memberships - for private rooms',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportRoomMemberList',
        component: () => import('pages/micros/support/roomMember/RoomMemberList.vue'),
        meta: {
          title: 'Room Memberships List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSupportRoomMemberDetail',
        component: () => import('pages/micros/support/roomMember/RoomMemberDetail.vue'),
        meta: {
          title: 'Room Membership Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportRoomMemberNew',
        component: () => import('pages/micros/support/roomMember/RoomMemberNew.vue'),
        meta: {
          title: 'New Room Membership',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/support/blog',
    name: 'infoSupportBlog',
    redirect: '/info/support/blog/list',
    component: () => import('pages/micros/support/blog/SupportBlog.vue'),
    meta: {
      title: 'Blogs - general, news, product etc.',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportBlogList',
        component: () => import('pages/micros/support/blog/BlogList.vue'),
        meta: {
          title: 'Blogs List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSupportBlogDetail',
        component: () => import('pages/micros/support/blog/BlogDetail.vue'),
        meta: {
          title: 'Blog Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportBlogNew',
        component: () => import('pages/micros/support/blog/BlogNew.vue'),
        meta: {
          title: 'New Blog',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'infoSupportBlogExplorer',
        component: () => import('pages/micros/support/blog/BlogExplorer.vue'),
        meta: {
          title: 'Blogs Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/support/chat',
    name: 'infoSupportChat',
    redirect: '/info/support/chat/list',
    component: () => import('pages/micros/support/chat/SupportChat.vue'),
    meta: {
      title: 'Chats - P2P | P2Group or P2Room real-time/off-line conversations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportChatList',
        component: () => import('pages/micros/support/chat/SioChats.vue'),
        meta: {
          title: 'Chats List - P2P Chats',
          requiresAuth: true,
        },
      },
      {
        path: 'room/chats',
        name: 'infoSupportRoomChats',
        component: () => import('pages/micros/support/chat/SioRooms.vue'),
        meta: {
          title: 'Room Chats List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSupportChatDetail',
        component: () => import('pages/micros/support/chat/SioChatDetail.vue'),
        meta: {
          title: 'Chat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportChatNew',
        component: () => import('pages/micros/support/chat/ChatNew.vue'),
        meta: {
          title: 'New Chat',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'infoSupportChatExplorer',
        component: () => import('pages/micros/support/chat/ChatExplorer.vue'),
        meta: {
          title: 'Chats Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'status/list',
        name: 'infoSupportChatStatusList',
        component: () => import('pages/micros/support/chatStatus/SioChatStatusList.vue'),
        meta: {
          title: 'Chat Statuses List',
          requiresAuth: true,
        },
      },
      {
        path: 'status/detail/:itemId?',
        name: 'infoSupportChatStatusDetail',
        component: () => import('pages/micros/support/chatStatus/SioChatStatusDetail.vue'),
        meta: {
          title: 'ChatStatus Details',
          requiresAuth: true,
        },
      },
      {
        path: 'status/new',
        name: 'infoSupportChatStatusNew',
        component: () => import('pages/micros/support/chatStatus/ChatStatusNew.vue'),
        meta: {
          title: 'New Chat Status',
          requiresAuth: true,
        },
      },
      {
        path: 'access/list',
        name: 'infoSupportChatAccessList',
        component: () => import('pages/micros/support/chatAccess/SioChatAccessList.vue'),
        meta: {
          title: 'Chat Accesses List',
          requiresAuth: true,
        },
      },
      {
        path: 'access/detail/:itemId?',
        name: 'infoSupportChatAccessDetail',
        component: () => import('pages/micros/support/chatAccess/SioChatAccessDetail.vue'),
        meta: {
          title: 'Chat Access Details',
          requiresAuth: true,
        },
      },
      {
        path: 'access/new',
        name: 'infoSupportChatAccessNew',
        component: () => import('pages/micros/support/chatAccess/ChatAccessNew.vue'),
        meta: {
          title: 'New Chat Access',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/support/chats',
    name: 'infoSupportChats',
    component: () => import('pages/micros/support/chat/SioChats.vue'),
    meta: {
      title: 'Chats [P2P | User]',
      requiresAuth: true,
    },
  },
  {
    path: '/info/support/p2p/chat',
    name: 'infoSupportP2PChat',
    component: () => import('pages/micros/support/chat/P2PChat.vue'),
    meta: {
      title: 'P2P Chat [Registered user and/or Guest]',
      requiresAuth: false,
    },
  },
  {
    path: '/info/support/rooms',
    name: 'infoSupportRooms',
    component: () => import('pages/micros/support/chat/SioRooms.vue'),
    meta: {
      title: 'Chat Rooms',
      requiresAuth: true,
    },
  },
  {
    path: '/info/support/join/room',
    name: 'infoSupportJoinRoom',
    component: () => import('pages/micros/support/chat/SioJoinRoom.vue'),
    meta: {
      title: 'Join Rooms',
      requiresAuth: true,
    },
  },
  {
    path: '/info/support/message',
    name: 'infoSupportMessage',
    redirect: '/info/support/message/list',
    component: () => import('pages/micros/support/message/SupportMessage.vue'),
    meta: {
      title: 'Messages - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportMessageList',
        component: () => import('pages/micros/support/message/MessageExplorerList.vue'),
        meta: {
          title: 'Messages List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:taskType?',
        name: 'infoSupportMessageDetail',
        component: () => import('pages/micros/support/message/MessageDetail.vue'),
        meta: {
          title: 'Message Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportMessageNew',
        component: () => import('pages/micros/support/message/MessageNew.vue'),
        meta: {
          title: 'New Message',
          requiresAuth: true,
        },
      },
      {
        path: 'status/list',
        name: 'infoSupportMessageStatusList',
        component: () => import('pages/micros/support/message/MessageStatusList.vue'),
        meta: {
          title: 'Message Statuses List',
          requiresAuth: true,
        },
      },
      {
        path: 'status/detail/:itemId?',
        name: 'infoSupportMessageStatusDetail',
        component: () => import('pages/micros/support/message/MessageStatusDetail.vue'),
        meta: {
          title: 'Message Status Details',
          requiresAuth: true,
        },
      },
      {
        path: 'status/new',
        name: 'infoSupportMessageStatusNew',
        component: () => import('pages/micros/support/message/MessageStatusNew.vue'),
        meta: {
          title: 'New Message Status',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/support/request',
    name: 'infoSupportRequest',
    redirect: '/info/support/request/list',
    component: () => import('pages/micros/support/request/SupportRequest.vue'),
    meta: {
      title: 'Requests - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportRequestList',
        component: () => import('pages/micros/support/request/RequestList.vue'),
        meta: {
          title: 'Requests List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSupportRequestDetail',
        component: () => import('pages/micros/support/request/RequestDetail.vue'),
        meta: {
          title: 'Request Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportRequestNew',
        component: () => import('pages/micros/support/request/RequestNew.vue'),
        meta: {
          title: 'New Request',
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/info/support/comment',
    name: 'infoSupportComment',
    redirect: '/info/support/comment/list',
    component: () => import('pages/micros/support/comment/SupportComment.vue'),
    meta: {
      title: 'Support Comments - for product items...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportCommentList',
        component: () => import('pages/micros/support/comment/CommentList.vue'),
        meta: {
          title: 'Comments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSupportCommentDetail',
        component: () => import('pages/micros/support/comment/CommentDetail.vue'),
        meta: {
          title: 'Comment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportCommentNew',
        component: () => import('pages/micros/support/comment/CommentNew.vue'),
        meta: {
          title: 'New Comment',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/list',
        name: 'infoSupportCommentStatList',
        component: () => import('pages/micros/support/commentStat/CommentStatList.vue'),
        meta: {
          title: 'Comment Stats List',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/detail/:itemId?',
        name: 'infoSupportCommentStatDetail',
        component: () => import('pages/micros/support/commentStat/CommentStatDetail.vue'),
        meta: {
          title: 'Comment Stat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/new',
        name: 'infoSupportCommentStatNew',
        component: () => import('pages/micros/support/commentStat/CommentStatNew.vue'),
        meta: {
          title: 'New Comment Stat',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/support/rate',
    name: 'infoSupportRate',
    redirect: '/info/support/rate/list',
    component: () => import('pages/micros/support/rate/SupportRate.vue'),
    meta: {
      title: 'Rates - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportRateList',
        component: () => import('pages/micros/support/rate/RateList.vue'),
        meta: {
          title: 'Rates List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSupportRateDetail',
        component: () => import('pages/micros/support/rate/RateDetail.vue'),
        meta: {
          title: 'Rate Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportRateNew',
        component: () => import('pages/micros/support/rate/RateNew.vue'),
        meta: {
          title: 'New Rate',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/support/rating',
    name: 'infoSupportRating',
    redirect: '/info/support/rating/list',
    component: () => import('pages/micros/support/rating/SupportRating.vue'),
    meta: {
      title: 'Ratings - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSupportRatingList',
        component: () => import('pages/micros/support/rating/RatingList.vue'),
        meta: {
          title: 'Ratings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSupportRatingDetail',
        component: () => import('pages/micros/support/rating/RatingDetail.vue'),
        meta: {
          title: 'Rating Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSupportRatingNew',
        component: () => import('pages/micros/support/rating/RatingNew.vue'),
        meta: {
          title: 'New Rating',
          requiresAuth: true,
        },
      },
    ],
  },
];
